module.exports = __webpack_public_path__ + "img/wallet.70cd1f98.svg";